const ListViewIcon = ({ className, ...rest }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-4 h-4"}
    {...rest}
  >
    <g fill="currentColor" clipPath="url(#clip0_10604_136692)">
      <path d="M13.08 5.255H7.43a.921.921 0 0 0 0 1.841h5.65a.921.921 0 0 0 0-1.84M4.92 5.255a.922.922 0 0 0 0 1.841.922.922 0 0 0 0-1.84M4.92 8.08a.922.922 0 0 0 0 1.84.922.922 0 0 0 0-1.84M4.92 10.904a.922.922 0 0 0 0 1.84.922.922 0 0 0 0-1.84M13.08 8.08H7.43a.921.921 0 0 0 0 1.84h5.65a.921.921 0 0 0 0-1.84M13.08 10.904H7.43a.921.921 0 0 0 0 1.84h5.65a.921.921 0 0 0 0-1.84"></path>
    </g>
    <defs>
      <clipPath id="clip0_10604_136692">
        <path fill="currentColor" d="M4 4h10v10H4z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default ListViewIcon;
